export default "__VITE_ASSET__7902bd7d__"